import { useEffect, useState } from "react";
import { Status } from "../../@types/status";
import { getStatuses } from "../../service/ticket";

export function useForm() {
    const [statuses, setStatuses] = useState<Status[]>([]);

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const statusData = await getStatuses();
                setStatuses(statusData.all_statuses || []);
            } catch (error) {
                console.error("Error fetching statuses:", error);
            }
        };
        fetchStatuses();
    }, []);

    return {
        statuses,
    };
}